<div class="wx-icon" [ngClass]="cssClass" [matTooltip]="tooltip"></div>
